import { render } from "./Variant_Pathways.vue?vue&type=template&id=6adf69fa"
import script from "./Variant_Pathways.vue?vue&type=script&lang=js"
export * from "./Variant_Pathways.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__